export default {"src":"/_next/static/media/geographic.93b13a07.svg","height":100,"width":100,"blurWidth":0,"blurHeight":0};